import { Directive } from '@angular/core';

@Directive({
    selector: '[uikit-prefix]',
})
export class UIKitPrefix { }
